import type {PropsWithChildren} from "shared/types";
import styles from "./styles.module.scss";

export const BlockEditorTableComponent = (props: PropsWithChildren) => {
  return (
    <table className={styles.table}>
      {props.children}
    </table>
  );
};